import nanoid from 'nanoid'

export const NEW_TASK = 'NEW_TASK'
export const newTask = () => {
  return { type: NEW_TASK, id: nanoid(), startDate: Date.now() }
}

export const TASK_TYPE = 'TASK_TYPE'
export const taskType = (task, newTypes) => {
  return { type: TASK_TYPE, task, newTypes }
}

export const ROW_NUMBER = 'ROW_NUMBER'
export const rowNumber = (task, rowNumber) => {
  return { type: ROW_NUMBER, task, rowNumber }
}

export const CHANGE_GH = 'CHANGE_GH'
export const changeGh = (task, greenhouse) => {
  return { type: CHANGE_GH, task, greenhouse }
}

export const END_TASK = 'END_TASK'
export const endTask = task => {
  return { type: END_TASK, endDate: Date.now(), task }
}

export const LOG_IN = 'LOG_IN'
export const logIn = user => {
  return { type: LOG_IN, user }
}

export const LOG_OUT = 'LOG_OUT'
export const logOut = () => {
  return { type: LOG_OUT }
}

export const SHOW_MENU = 'SHOW_MENU'
export const showMenu = () => {
  return { type: SHOW_MENU }
}

export const HIDE_MENU = 'HIDE_MENU'
export const hideMenu = () => {
  return { type: HIDE_MENU }
}

export const CLEAR_ENTRIES = 'CLEAR_ENTRIES'
export const clearEntries = () => {
  return { type: CLEAR_ENTRIES }
}



// WEBPACK FOOTER //
// ./src/model/actions.js